<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Travel Sheet</h5>
  </div>
  <div id="mainContent" class="container">

    <div class="pt-2">
      <div class="row">
        <div class="col-md-3">
          <label class="mb-0">Financial Year :</label>
          <select class="form-control form-control-xs" [id]="'branch'" [name]="'branch'" type="text"
            class="form-control form-control-xs" (change)="getAllTravelSheetList()" [(ngModel)]="selectedFY"
            matTooltip="select Fy year" matTooltipPosition="above">
            <option>Select</option>
            <option *ngFor="let financialYear of financialYearList" [ngValue]="financialYear">{{ financialYear.name }}
            </option>
          </select>
        </div>
        <div class="col-md-3"></div>

        <div class="col-md-6">
          <button class="btn btn-xs btn-theme" style="float: right" matTooltip="Click to add" matTooltipPosition="left"
            (click)="openModalClick(modalContent)">
            <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;New
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <!-- style="display: block; overflow-x: auto; white-space: nowrap" -->
          <table class="table table-bordered table-sm table-striped">
            <thead class="">
              <tr>
                <th width="8%">Action</th>
                <th>Document</th>
                <th>Status</th>
                <th>Approver Name</th>
                <th>Entry Date</th>
                <th>Client</th>
                <th>Assignment</th>
                <th>Financial Year</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Total</th>

                <th>Remark</th>
              </tr>
            </thead>
            <tbody *ngFor="let travelsheet of travelSheetList">
              <tr>
                <td width="8%">
                  <button class="btn" style="padding: 2px" (click)="onViewClick(travelsheet, viewModalContent)">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                  <button class="btn" style="padding: 2px" (click)="onEditClick(travelsheet, modalContent)"
                    [disabled]="travelsheet.sheetStatus == 'Approved'">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button>
                  <button class="btn ml-1" style="padding: 2px" (click)="onDeleteClick(travelsheet)"
                    [disabled]="travelsheet.sheetStatus == 'Approved'">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <a style=" color: #800000; cursor: pointer;text-decoration: underline;"
                    (click)="openDocumentModal(viewDocumentContent, travelsheet.fareDocuments)">
                    Documents
                  </a>
                </td>
                <td>{{ travelsheet.sheetStatus }}</td>
                <td *ngIf="!approverName; else elseBlock">
                  {{ travelsheet.approver.firstName }}
                  {{ travelsheet.approver.middleName }}
                  {{ travelsheet.approver.lastName }}
                </td>
                <ng-template #elseBlock>
                  <td *ngIf="userId==52 || branchName != 'Pune' else elseBlock1">Self Approved</td>
                  <ng-template #elseBlock1>
                    <td>{{ travelsheet.approver.firstName }}
                      {{ travelsheet.approver.middleName }}
                      {{ travelsheet.approver.lastName }}</td>
                  </ng-template>
                </ng-template>
                <td>
                  {{ travelsheet.entryDate.day }}-{{
                  changeMonthNumberToName(travelsheet.entryDate.month)
                  }}-{{ travelsheet.entryDate.year }}
                </td>
                <td>{{ travelsheet.client.name }}</td>
                <td>{{ travelsheet.assignment.name }}</td>
                <td>{{ travelsheet.fy.name }}</td>
                <td>
                  {{ travelsheet.fromDate.day }}-{{
                  changeMonthNumberToName(travelsheet.fromDate.month)
                  }}-{{ travelsheet.fromDate.year }}
                </td>
                <td>
                  {{ travelsheet.toDate.day }}-{{
                  changeMonthNumberToName(travelsheet.toDate.month)
                  }}-{{ travelsheet.toDate.year }}
                </td>
                <td>{{ travelsheet.totalAmount }}</td>
                <td>{{ travelsheet.remark }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
      Travel Sheet Entry Details
    </h5>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-4">
        <div class="row">
          <label class="col-md-3 col-form-label">Approver<span class="text-danger">*</span>
          </label>
          <div class="col-md-9" *ngIf="approverList.length > 0; else other_content">
            <select ngbAutofocus class="form-control form-control-xs" id="approver" name="approver"
              [(ngModel)]="travelSheetModel.approver">
              <option [ngValue]="null">Select Approver Name</option>
              <option *ngFor="let approver of approverList" [ngValue]="approver">
                {{ approver.firstName }} {{ approver.lastName }}
              </option>
            </select>
          </div>
          <ng-template #other_content>
            <div class="col-md-9"
              *ngIf="((userRole == 'Partner' || userRole == 'Designated Partner')) && clientHasPGB == false else elseBlock">
              <input type="text" value="Self Approved" class="form-control form-control-xs" [disabled]="true" />
            </div>
            <ng-template #elseBlock>
              <div class="col-md-9">
                <input type="text" value="Abhijeet Bhagwat" class="form-control form-control-xs" [disabled]="true" />
              </div>
            </ng-template>
          </ng-template>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row">
          <label class="col-md-3 col-form-label">Date<span class="text-danger">*</span>
          </label>
          <div class="col-md-9">
            <div class="input-group">
              <input id="entryDate" name="entryDate" class="form-control form-control-xs setColor"
                placeholder="dd/mm/yyyy" ngbDatepicker #entryDate="ngbDatepicker" [(ngModel)]="selectedEntryDate"
                (dateSelect)="onEntryDateSelect()" [minDate]="currentDate" [maxDate]="currentDate" [readonly]="true" />

              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="entryDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row">
          <label class="col-md-3 col-form-label">Client<span class="text-danger">*</span>
          </label>
          <div class="col-md-9">
            <select class="form-control form-control-xs" id="client" name="client" [(ngModel)]="travelSheetModel.client"
              (change)="afterClientSelect()">
              <option [ngValue]="null">Select Client Name</option>
              <option *ngFor="let client of clientList" [ngValue]="client">
                {{ client.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Client<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <select
              class="form-control form-control-xs"
              id="client"
              name="client"
              [(ngModel)]="travelSheetModel.client"
              (change)="afterClientSelect()"
            >
              <option [ngValue]="null">Select Client Name</option>
              <option *ngFor="let client of clientList" [ngValue]="client">
                {{ client.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label for="assignmentId" class="col-sm-4 col-form-label"
            >Assignment<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <select
              class="form-control form-control-xs"
              id="assignment"
              name="assignment"
              [(ngModel)]="travelSheetModel.assignment"
            >
              <option [ngValue]="null">Select Assignment Name</option>
              <option
                *ngFor="let assignment of assignmentList"
                [ngValue]="assignment"
              >
                {{ assignment.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row">
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
            <label class="col-form-label">Chargable To Client<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-0" style="margin-top: -2%">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="clientChargeYes" id="clientChargeYes"
                  [(ngModel)]="travelSheetModel.chargeble" [value]="true" disabled />
                <label class="col-form-label" style="font-weight: 400">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="clientChargeNo" id="clientChargeNo" disabled
                  [(ngModel)]="travelSheetModel.chargeble" [value]="false" />
                <label class="col-form-label" style="font-weight: 400">No</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <label for="assignmentId" class="col-md-4 col-form-label">Assignment<span class="text-danger">*</span>
          </label>
          <div class="col-md-8">
            <select class="form-control form-control-xs" id="assignment" name="assignment"
              [(ngModel)]="travelSheetModel.assignment">
              <option [ngValue]="null">Select Assignment Name</option>
              <option *ngFor="let assignment of assignmentList" [ngValue]="assignment">
                {{ assignment.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row">
          <label for="clientForFY" class="col-md-3 col-form-label">For FY<span class="text-danger">*</span>
          </label>
          <div class="col-md-9">
            <select class="form-control form-control-xs" id="clientForFY" name="clientForFY"
              [(ngModel)]="travelSheetModel.fy" (change)="checkBudgetAfterFyClick()">
              <option [ngValue]="null">Select For FY</option>
              <option *ngFor="let clientForFY of financialYearList" [ngValue]="clientForFY">
                {{ clientForFY.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
            <label class="col-form-label"
              >No Of Person Travelling<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-6">
            <input
              type="number"
              id="noOfPerson"
              name="noOfPerson"
              class="form-control form-control-xs"
              [(ngModel)]="travelSheetModel.noOfPersons"
              (blur)="noOfPersonValue()"
            />
          </div>
        </div>
      </div>
    </div>
    <hr /> -->
    <!-- <div class="row">
      <div class="col-sm-6">
        <label class="col-form-label">Period Of Travel </label>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-5">
            <label class="col-form-label">From Date<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-md-7">
            <div class="input-group">
              <input id="fromDate" name="fromDate" class="form-control form-control-xs setColor"
                placeholder="dd/mm/yyyy" ngbDatepicker #fromDate="ngbDatepicker" [(ngModel)]="selectedFromDate"
                (dateSelect)="onFromDateSelect()" [readonly]="true" />
              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="fromDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-5">
            <label class="col-form-label">To Date<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-md-7">
            <div class="input-group">
              <input id="toDate" name="toDate" class="form-control form-control-xs setColor" placeholder="dd/mm/yyyy"
                ngbDatepicker #toDate="ngbDatepicker" [minDate]="selectedFromDate" [maxDate]="currentDate"
                [(ngModel)]="selectedToDate" (dateSelect)="onToDateSelect()" [readonly]="true" />
              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="toDate.toggle()" type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
            <label class="col-form-label">No Of Persons<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-md-6">
            <input type="number" id="noOfPerson" name="noOfPerson" class="form-control form-control-xs"
              [(ngModel)]="travelSheetModel.noOfPersons" (blur)="noOfPersonValue()" />
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Particulars</label>
      </div>
      <div class="col-md-3">
        <label class="col-form-label">Amount</label>
      </div>
      <div class="col-md-3">
        <label class="col-form-label"> GST Amount</label>
      </div>
      <div class="col-md-3" *ngIf="showLableUpload">
        <label class="col-form-label">Supporting to be upload</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3"><label class="col-form-label">Train</label></div>
      <div class="col-md-3">
        <input type="number" id="trainAmount" name="trainAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.trainAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
       <div class="col-md-3">
        <input type="number" id="trainGstAmount" name="trainGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.trainGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showTrainFileChoose">
        <div>
          <input id="trainfile" type="file" #trainfile multiple class="custome_file"
            (change)="fileChange($event, 'train')" placeholder="Upload file"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        </div>
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'train'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3"><label class="col-form-label">Air</label></div>
      <div class="col-md-3">
        <input type="number" id="airAmount" name="airAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.airAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="airGstAmount" name="airGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.airGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showAirFileChoose">
        <div>
          <input id="airfile" type="file" #airfile multiple class="custome_file" (change)="fileChange($event, 'air')"
            placeholder="Upload file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        </div>
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'air'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3"><label class="col-form-label">Taxi</label></div>
      <div class="col-md-3">
        <input type="number" id="taxiAmount" name="taxiAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.taxiAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="taxiGstAmount" name="taxiGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.taxiGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showTaxiFileChoose">
        <input id="taxifile" type="file" #taxifile multiple class="custome_file" (change)="fileChange($event, 'taxi')"
          placeholder="Upload file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'taxi'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3"><label class="col-form-label">Car</label></div>
      <div class="col-md-3">
        <!-- <span>{{ travelSheetModel.carAmount }}</span> -->
        <input type="number" id="carAmount" name="carAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.carAmount" disabled />
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <input #refCar type="number" id="carInKms" name="carInKms" class="form-control form-control-xs"
              [(ngModel)]="travelSheetModel.kms" (ngModelChange)="calculateCarAmount(refCar.value)" />
          </div>
          <div><label class="col-form-label">Kms.</label></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Toll </label>
      </div>
      <div class="col-md-3">
        <input type="number" id="carToll" name="carToll" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.toll" (ngModelChange)="calculateAllTotal()" (blur)="tollValue()" />
      </div>
      <div class="col-md-6" *ngIf="showTollFileChoose">
        <input id="toll" type="file" #tollfile multiple class="custome_file" (change)="fileChange($event, 'toll')"
          placeholder="Upload file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'toll'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Hotel Stay</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="hotelStay" name="hotelStay" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.hotelAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="hotelGstAmount" name="hotelGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.hotelGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showHotelFileChoose">
        <input id="hotelstayfile" type="file" #hotelstayfile multiple class="custome_file"
          (change)="fileChange($event, 'hotelStay')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'hotelStay'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Food Expense</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="foodExpense" name="foodExpense" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.foodAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="foodGstAmount" name="foodGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.foodGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showFoodFileChoose">
        <input id="foodexpfile" type="file" #foodexpfile multiple class="custome_file"
          (change)="fileChange($event, 'foodExpense')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'foodExpense'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Mobile</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="mobile" name="mobile" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.mobileAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="mobileGstAmount" name="mobileGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.mobileGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showMobileFileChoose">
        <input id="mobileFile" type="file" #mobileFile multiple class="custome_file"
          (change)="fileChange($event, 'mobile')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'mobile'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Internet</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="internet" name="internet" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.internetAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="internetGstAmount" name="internetGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.internetGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showInternetFileChoose">
        <input id="internetFile" type="file" #internetFile multiple class="custome_file"
          (change)="fileChange($event, 'internet')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'internet'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">ICAI Membership fee</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="icaiMembershipFee" name="icaiMembershipFee" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.icaiMembershipFee" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="icaiMembershipGstAmount" name="icaiMembershipGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.icaiMembershipGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showICAIMembFileChoose">
        <input id="icaiMembershipFeeFile" type="file" #icaiMembershipFeeFile multiple class="custome_file"
          (change)="fileChange($event, 'icaiMembershipFee')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'icaiMembershipFee'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Microsoft 365 Subscription</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="microsoft365Subscription" name="microsoft365Subscription"
          class="form-control form-control-xs" [(ngModel)]="travelSheetModel.microsoft365Subscription"
          (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="microsoft365SubscriptionGstAmount" name="microsoft365SubscriptionGstAmount"
          class="form-control form-control-xs" [(ngModel)]="travelSheetModel.microsoft365SubscriptionGstAmount"
          (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showMicrosoftSubFileChoose">
        <input id="microsoftSubFile" type="file" #microsoftSubFile multiple class="custome_file"
          (change)="fileChange($event, 'microsoft365Subscription')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'microsoft365Subscription'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash" style="color:#800000"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Seminar Fee</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="seminarFee" name="seminarFee" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.seminarFee" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="seminarFeeGstAmount" name="seminarFeeGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.seminarFeeGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3" *ngIf="showSeminarFeeFileChoose">
        <input id="seminarFeeFile" type="file" #seminarFeeFile multiple class="custome_file"
          (change)="fileChange($event, 'seminarFee')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'seminarFee'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash" style="color:#800000"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Others</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="otherAmount" name="otherAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.otherAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <div class="col-md-3">
        <input type="number" id="otherGstAmount" name="otherGstAmount" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.otherGstAmount" (ngModelChange)="calculateAllTotal()" />
      </div>
      <!-- (blur)="needNauterOfExpense()" -->
      <div class="col-md-3" *ngIf="showOthersFileChoose">
        <input id="otherfile" type="file" #otherfile multiple class="custome_file"
          (change)="fileChange($event, 'others')" placeholder="Upload file"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.rtf,.xlsx,.xls" />
        <div class="row" style="margin-left: 6px">
          <div *ngFor="let docURL of travelSheetModel.fareDocuments; let i = index">
            <div *ngIf="docURL.type == 'others'">
              <a href="{{ docURL.url }}" target="_blank" rel="noopener noreferrer">
                <span style="color:#800000"> {{ docURL.name }} </span>
              </a>
              <span class="" style="color: #800000; cursor: pointer" (click)="deleteDocument(docURL, i)">
                <i class="fa fa-trash" style="color:#800000"></i>,
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="showOthersFileChoose">
      <label class="col-md-3 col-form-label">Nature Of Expense :</label>
      <div class="col-md-9">
        <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
          id="natureofexpense" name="natureofexpense" [(ngModel)]="travelSheetModel.natureOfExpense"></textarea>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-3">
        <label class="col-form-label">Total</label>
      </div>
      <div class="col-md-3">
        <!-- <span>{{ travelSheetModel.totalAmount }}</span> -->
        <input type="number" id="totalAmount" name="totalAmount" class="form-control form-control-xs" disabled
          [(ngModel)]="travelSheetModel.totalAmount" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Advance Taken</label>
      </div>
      <div class="col-md-3">
        <input type="number" id="advanceTaken" name="advanceTaken" class="form-control form-control-xs"
          [(ngModel)]="travelSheetModel.advanceTaken" (ngModelChange)="netPayableTotalAmount()" />
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label">Advance Approver</label>
          </div>
          <div class="col-md-6">
            <select ngbAutofocus class="form-control form-control-xs" id="advanceApprover" name="advanceApprover"
              [(ngModel)]="travelSheetModel.advanceApprover">
              <option [ngValue]="null">Select Approver Name</option>
              <option *ngFor="let approver of approverList" [ngValue]="approver">
                {{ approver.firstName }} {{ approver.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Net payable / receivable</label>
      </div>
      <div class="col-md-3">
        <!-- <span>{{ travelSheetModel.netPayable }}</span> -->
        <input type="number" id="netPayable" name="netPayable" class="form-control form-control-xs" disabled
          [(ngModel)]="travelSheetModel.netPayable" />
      </div>
      <!-- <div class="col-md-3">
        <button class="btn btn-light btn-md" (click)="netPayableTotalAmount()">
          Calculate NetPayable
        </button>
      </div> -->
    </div>
    <div class="row">
      <label class="col-md-3 col-form-label">Remark :</label>
      <div class="col-md-9">
        <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs" id="remark"
          name="remark" [(ngModel)]="travelSheetModel.remark"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-md-6"></div>
      <div class="col-md-3">
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()"
          *ngIf="!hideSaveButton">
          Save
        </button>
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()"
          *ngIf="hideSaveButton">
          <span *ngIf="!buttonChangeStatus">Update</span>
          <span *ngIf="buttonChangeStatus">Update & Submit</span>
        </button>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewModalContent let-modalView>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">View Travel Sheet</h5>
  </div>
  <div class="modal-body">
    <div class="row mb-1">
      <div class="col-sm-3"><label>Approver Name</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.approver.firstName }}
          {{ travelSheetModel.approver.middleName }}
          {{ travelSheetModel.approver.lastName }}
        </span>
      </div>
      <div class="col-sm-3"><label>Date </label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.entryDate.day }}-{{
          changeMonthNumberToName(travelSheetModel.entryDate.month)
          }}-{{ travelSheetModel.entryDate.year }} </span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Client Name</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.client.name }}</span>
      </div>
      <div class="col-sm-3"><label>Chargable To Client</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.chargeble == true ? "Yes" : "No" }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Assignment</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.assignment.name }}</span>
      </div>
      <div class="col-sm-3"><label>Financial Year</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.fy.name }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>From Date</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.fromDate.day }}-{{
          changeMonthNumberToName(travelSheetModel.fromDate.month)
          }}-{{ travelSheetModel.fromDate.year }}
        </span>
      </div>
      <div class="col-sm-3"><label>To Date</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>
          {{ travelSheetModel.toDate.day }}-{{
          changeMonthNumberToName(travelSheetModel.toDate.month)
          }}-{{ travelSheetModel.toDate.year }}
        </span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3">
        <label>No Of Persons</label>
      </div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.noOfPersons }}</span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Particulars</label>
      </div>
    </div>
    <div class="row mb-1">
  <div class="col-sm-3"><label>Train Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.trainAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Train GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.trainGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Air Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.airAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Air GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.airGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Taxi Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.taxiAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Taxi GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.taxiGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Hotel Stay Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.hotelAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Hotel GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.hotelGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Food Expense Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.foodAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Food GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.foodGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Mobile Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.mobileAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Mobile GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.mobileGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Internet Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.internetAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Internet GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.internetGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>ICAI Membership Fee</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.icaiMembershipFee }}</span>
  </div>

  <div class="col-sm-3"><label>ICAI Membership GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.icaiMembershipGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Microsoft 365 Subscription</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.microsoft365Subscription }}</span>
  </div>

  <div class="col-sm-3"><label>Microsoft 365 GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.microsoft365SubscriptionGstAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Seminar Fee</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.seminarFee }}</span>
  </div>

  <div class="col-sm-3"><label>Seminar GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.seminarFeeGstAmount }}</span>
  </div>
</div>

<hr />

<div class="row mb-1">
  <div class="col-sm-3"><label>Car Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.carAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Toll Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.toll }}</span>
  </div>
</div>

<hr />

<div class="row mb-1">
  <div class="col-sm-3"><label>Others Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.otherAmount }}</span>
  </div>

  <div class="col-sm-3"><label>Other GST Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.otherGstAmount }}</span>
  </div>
</div>

<hr />

<div class="row mb-1">
  <div class="col-sm-3"><label>Nature Of Expense</label></div>
  <div class="col-sm-9">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.natureOfExpense }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Total Amount</label></div>
  <div class="col-sm-9">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.totalAmount }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Advance Taken Amount</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.advanceTaken }}</span>
  </div>

  <div class="col-sm-3"><label>Advance Approver</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span *ngIf="travelSheetModel.advanceApprover != null">
      {{ travelSheetModel.advanceApprover.firstName }}
      {{ travelSheetModel.advanceApprover.middleName }}
      {{ travelSheetModel.advanceApprover.lastName }}
    </span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Net payable / receivable</label></div>
  <div class="col-sm-3">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.netPayable | number:'1.2-2' }}</span>
  </div>
</div>

<div class="row mb-1">
  <div class="col-sm-3"><label>Remark</label></div>
  <div class="col-sm-9">
    <label>:&nbsp;&nbsp;</label>
    <span>{{ travelSheetModel.remark }}</span>
  </div>
</div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modalView.dismiss('Cross click')">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewDocumentContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Perticulars Documents</h5>
  </div>
  <div class="modal-body">
    <table class="table table-fixed table-bordered">
      <thead>
        <th>Type</th>
        <th>Name</th>
        <th>Url</th>
      </thead>
      <tbody *ngFor="let document of fareDocumentsList; let i = index">
        <td>{{ document.type }}</td>
        <td>{{ document.name }}</td>
        <td>
          <a href="{{ document.url }}" target="_blank" rel="noopener noreferrer"><i class="fa fa-download fa-lg"
              style="color:#800000"></i></a>
        </td>
      </tbody>
    </table>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button id="closeStandardBtn" name="closeStandardBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>